/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Not_AvailableInputs */

const cs_franchise_not_available = /** @type {(inputs: Franchise_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Správa franšízy je dostupná pouze pro franchisora.`)
};

const en_franchise_not_available = /** @type {(inputs: Franchise_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchise management is available to franchisors only.`)
};

/**
* | output |
* | --- |
* | "Franchise management is available to franchisors only." |
*
* @param {Franchise_Not_AvailableInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_not_available = /** @type {((inputs?: Franchise_Not_AvailableInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Not_AvailableInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_not_available(inputs)
	return cs_franchise_not_available(inputs)
});